import usePaymentTerm from '../usePaymentTerm'

type PaymentTermTextProps = {
	databaseSource?: string
	companyUUID?: string
	value?: number
}

const PaymentTermText = (props: PaymentTermTextProps) => {
	const { databaseSource, companyUUID, value: id } = props
	const { paymentTerm } = usePaymentTerm({
		databaseSource,
		companyUUID,
		paymentTermId: id,
	})
	return <> {paymentTerm?.description} </>
}

export default PaymentTermText
